export default __webpack_public_path__ + "static/media/dizzi-aple.9ef92950.png";